import React from "react";
import "./loader.css";

export default function Loader() {
  return (
    <div className={"loader-container show-loader"}>
      <div
        className="spinner-border  text-light"
        style={{ height: "50px", width: "50px" }}
      >
        <span className="sr-only">Loading</span>
      </div>
    </div>
  );
}
